// This file should only contain action type constants.
export const SET_ITEMS = 'SET_ITEMS';
export const SET_NAVSV2 = 'SET_NAVS_V2';
export const SET_FRANCHISELIST = 'SET_FRANCHISELIST';
export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const CLOSE_ALL_MENUS = 'CLOSE_ALL_MENUS';
export const SET_ACCOUNT_ID = 'SET_ACCOUNT_ID';
export const SET_URI = 'SET_URI';
